(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aox4-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aox4-cart-count')) {
  customElements.define('aox4-cart-count', class extends HTMLElement {
    connectedCallback() {
      this.revision = 0;
      this.onCartUpdate = (event) => {
        if (!event.promise) return;
        const revision = ++this.revision;
        event.promise.then((result) => {
          if (!this.isConnected || revision !== this.revision) return;
          const count = result.cart?.totalQuantity ?? result.detail?.itemCount;
          if (Number.isInteger(count) && count >= 0) this.textContent = String(count);
        }).catch(() => {});
      };
      document.addEventListener('shopify:cart:lines-update', this.onCartUpdate);
    }
    disconnectedCallback() {
      document.removeEventListener('shopify:cart:lines-update', this.onCartUpdate);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aox4-launch"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('aox4-flavor-picker')) {
  customElements.define('aox4-flavor-picker', class extends HTMLElement {
    connectedCallback() {
      if (this._aox4Ready) return;
      this._aox4Ready = true;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-flavor]');
        if (!link || !this.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const signup = this.querySelector('#aox4-signup');
        const email = signup?.querySelector('input[type="email"]');
        const preference = signup?.querySelector('[data-signup-preference]');
        const tags = signup?.querySelector('input[name="contact[tags]"]');
        if (!email) return;
        event.preventDefault();
        if (tags) tags.value = 'newsletter,aox4-launch,flavor-' + link.dataset.tag;
        if (preference) {
          preference.textContent = preference.dataset.template.replace('[flavor]', link.dataset.flavor);
          preference.hidden = false;
        }
        signup.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
        email.focus({preventScroll: true});
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
